export const PUBLIC_ROUTE = {
  LANDING: '/',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  DASHBOARD_SIGN_UP: '/pnx-dashboard-signup',
  DOWNLOAD_APP: '/download_app',
  REDIRECT_CUSTOMER_INFO: '/redirect_customer_info/:id',
  REDIRECT: '/redirect/:id/:customer?',
  CUSTOMER_PAYMENT: '/customer_payment/:id',
  REDIRECT_SUCCESS: '/redirect_success',
  DASHBOARD_REGISTER_SUCCESS: '/pti_registration_success',
  DASHBOARD_REGISTER_FAILED: '/pti_registration_failed',
  DASHBOARD_REGISTER_EXPIRED: '/pti_registration_expired',
  DASHBOARD_REGISTER_ALREADY: '/pti_registration_already_registered',
  REDIRECT_FAILED: '/redirect_failed/:id',
  REDIRECT_ERROR: '/redirect_error',
  REDIRECT_REFUND: '/redirect_refund',
  REDIRECT_PENDING: '/redirect_pending',
  REDIRECT_STORE_NOT_ALLOWED: '/redirect_store_not_found',
  REDIRECT_VERIFIED_EMAIL: '/redirect_verified_email/:id',
  MERCHANT_QR: '/merchant_qr/:id',
  POS_MERCHANT: '/pos_merchant/:id',
  MERCHANT_KYC_DISPLAY: '/merchant_kyc_display/:id',
  REGISTRATION_SUCCESS: '/registration_success/:id',
  REGISTRATION_VERIFIED_EMAIL: '/registration_verified_email/:id',
  RESET_PASSWORD: '/reset_password/:id',
  REDIRECT_RESET_SUCCESS: '/redirect_reset_success',
  REDIRECT_RESET_EXPIRED: '/redirect_reset_expired',
  REDIRECT_RESET_USED: '/redirect_reset_used',
  REDIRECT_INVENTORY: '/redirect_inventory/:id',
  REDIRECT_VERIFY: '/redirect_verify/:id',
  REDIRECT_TOPUP_SUCCESS: '/redirect_topup_success',
  REDIRECT_TOPUP_FAILED: '/redirect_topup_failed/',
  TERMS_AND_CONDITIONS: '/terms_and_conditions',
  MOBILE_OPTION: '/mobile_option',
  SIGN_UP_REFER: '/signup/:referralCode',
  FORGET_PASSWORD: '/forgotpassword',
  RESETPASSWORD: '/resetpassword',
  CHANGEPASSWORD: '/change-password',
  PAGE_404: '/404',
  PAGE_500: '/500',
  AUTH0_CALLBACK: '/auth0loginCallback',
  UNSUBSCRIBE_SUCCESS: '/unsubscribe_success',
  UNSUBSCRIBE_FAILED: '/unsubscribe_failed',
  UNSUBSCRIBE_CONFIRM: '/unsubscribe_confirm/:id',
  REGISTER_MERCHANT_REFER: '/register_merchant_form',
  REGISTER_MERCHANT_REFER_FAILED: '/register_merchant_form_failed',
  MERCHANT_INFORMATION_FORM: '/merchant_information_form',
  MERCHANT_INFORMATION_FORM_EXPIRED: '/merchant_information_form_expired',
  MERCHANT_INFORMATION_FORM_SUCCESS: '/merchant_information_form_success',
  MERCHANT_INFORMATION_FORM_FAILED: '/merchant_information_form_failed',
  KYB_LINK: '/kyb_link/:id',
  KYB_LINK_EXPIRED: '/kyb_link_expired',
  KYB_LINK_SUCCESS: '/kyb_link_success',
  KYB_LINK_FAILED: '/kyb_link_failed'
};

// export const PRIVATE_ROUTE = {
//   DASHBOARD: '/',
//   MAIL: '/inbox',
//   SCRUM_BOARD: '/scrum-board',
//   CALENDAR: '/calendar',
//   GOOGLE_MAP: '/googlemap',
//   LEAFLET_MAP: '/leafletmap',
//   TABLE: '/table_ant',
//   FORM: '/allFormComponent',
//   INPUT: '/InputField',
//   EDITOR: '/editor',
//   FORM_WITH_STEPPERS: '/stepperForms',
//   FORM_WITH_VALIDATION: '/FormsWithValidation',
//   PROGRESS: '/progress',
//   BUTTON: '/button',
//   TAB: '/tab',
//   AUTOCOMPLETE: '/autocomplete',
//   CHECKBOX: '/checkbox',
//   RADIOBOX: '/radiobox',
//   SELECT: '/selectbox',
//   TRANSFER: '/transfer',
//   GRID_LAYOUT: '/gridLayout',
//   NOTES: '/notes',
//   TODO: '/todo',
//   ARTICLES: '/articles',
//   INVESTORS: '/investors',
//   CONTACTS: '/contacts',
//   ALERT: '/alert',
//   MODAL: '/modal',
//   MESSAGE: '/message',
//   NOTIFICATION: '/notification',
//   POPCONFIRM: '/Popconfirm',
//   SPIN: '/spin',
//   SHUFFLE: '/shuffle',
//   AFFIX: '/affix',
//   BREADCRUMB: '/breadcrumb',
//   BACK_TO_TOP: '/backToTop',
//   DROPDOWN: '/dropdown',
//   OP_BADGE: '/op_badge',
//   OP_CARD: '/op_card',
//   OP_CAROUSEL: '/op_carousel',
//   OP_COLLAPSE: '/op_collapse',
//   OP_TOOLTIP: '/op_tooltip',
//   RATING: '/rating',
//   TREE: '/tree',
//   OP_TAG: '/op_tag',
//   OP_TIMELINE: '/op_timeline',
//   OP_POPOVER: '/op_popover',
//   GOOGLE_CHART: '/googleChart',
//   RECHARTS: '/recharts',
//   MENU: '/menu',
//   REACT_CHART_2: '/ReactChart2',
//   PAGINATION: '/pagination',
//   CARD: '/card',
//   CART: '/cart',
//   CHECKOUT: '/checkout',
//   SHOP: '/shop',
//   REACT_DATES: '/reactDates',
//   CODE_MIRROR: '/codeMirror',
//   UPPY: '/uppy',
//   DROPZONE: '/dropzone',
//   YOUTUBE_SEARCH: '/youtubeSearch',
//   FRAPPE_CHART: '/frappeChart',
//   INVOICE: '/invoice',
//   CHAT: '/chat',
//   PROFILE: '/my-profile',
//   SWIPER_SLIDER: '/swiperslider',
//   CORPORATE_MERCHANT: '/CorporateMerchant',
// };
